import { Mixins, Component } from 'vue-property-decorator';
import EdCreateContentCard from '../../../../components/ed-create-content-card/ed-create-content-card.vue';
import { CORE_ROUTES } from '@/core/core.router';
import { MyContentViewsMixin } from '@/app/private/my-content/mixins/my-content-views.mixin';

@Component({
  name: 'subjects',
  components: {
    EdCreateContentCard
  }
})
export default class Subjects extends Mixins(MyContentViewsMixin) {

  public page: string = 'subjects';
  public hasLimit: boolean = true;
  declare limit: number;

  goToCreateCourse() {
    this.$router.push({
      name: CORE_ROUTES.CREATE_COURSE.NAME
    });
  }

  created() {
    let limit = Math.floor(window.innerWidth / 200);
    this.limit = limit == 1 ? 1 : (limit - 1);
  }

}
